var map = {
	"./AFN.svg": "e390",
	"./ALL.svg": "29e6",
	"./ANG.svg": "3f79",
	"./AWG.svg": "e008",
	"./AZN.svg": "a664",
	"./BAM.svg": "11a7",
	"./BGN.svg": "ee63",
	"./BOB.svg": "3d86",
	"./BRL.svg": "8588",
	"./BTC.svg": "9a37",
	"./BWP.svg": "7c3d",
	"./BYN.svg": "3c79",
	"./BZD.svg": "5bde",
	"./CAD.svg": "60e1",
	"./CHF.svg": "8e63",
	"./CNY.svg": "92f1",
	"./CRC.svg": "2a4b",
	"./CUP.svg": "92b5",
	"./CZK.svg": "3d40",
	"./DKK.svg": "5c61",
	"./DOP.svg": "0424",
	"./EEK.svg": "96e3",
	"./ETH.svg": "030e",
	"./EUR.svg": "c429",
	"./GBP.svg": "f7fc",
	"./GHC.svg": "f1e6",
	"./GTQ.svg": "b57c",
	"./HNL.svg": "95ba",
	"./HRK.svg": "24e3",
	"./HUF.svg": "b0fe",
	"./IDR.svg": "7cdb",
	"./ILS.svg": "202b",
	"./INR.svg": "2f1f",
	"./IRR.svg": "0bdd",
	"./ISK.svg": "338e",
	"./JMD.svg": "d561",
	"./JPY.svg": "2cd3",
	"./KGS.svg": "2ec3",
	"./KHR.svg": "c144",
	"./KPW.svg": "0e9c",
	"./KRW.svg": "ce22",
	"./KZT.svg": "ff6f",
	"./LAK.svg": "7e94",
	"./LKR.svg": "379c",
	"./LTL.svg": "c7fd",
	"./LVL.svg": "308b",
	"./MKD.svg": "1868",
	"./MNT.svg": "3d34c",
	"./MUR.svg": "d886",
	"./MYR.svg": "e7ed",
	"./MZN.svg": "98ed",
	"./NGN.svg": "6e0f",
	"./NIO.svg": "f994",
	"./NOK.svg": "576d",
	"./NPR.svg": "aaab",
	"./OMR.svg": "4396",
	"./PAB.svg": "953e",
	"./PEN.svg": "18fa",
	"./PHP.svg": "591e",
	"./PKR.svg": "8189",
	"./PLN.svg": "e9fe",
	"./PYG.svg": "c05b",
	"./QAR.svg": "8e45",
	"./RON.svg": "f633",
	"./RSD.svg": "456f",
	"./RUB.svg": "84f0",
	"./SAR.svg": "9cc9",
	"./SCR.svg": "1770",
	"./SEK.svg": "27a4",
	"./SOS.svg": "1462",
	"./THB.svg": "e5b3",
	"./TRY.svg": "8094",
	"./TTD.svg": "bde6",
	"./TWD.svg": "dc4c",
	"./UAH.svg": "78b9",
	"./USD.svg": "6e5d",
	"./UYU.svg": "1a25",
	"./UZS.svg": "a7b8",
	"./VES.svg": "6268",
	"./VND.svg": "e4c9",
	"./XLM.svg": "8bd6",
	"./XRP.svg": "ae55",
	"./YER.svg": "dead",
	"./ZAR.svg": "4042",
	"./ZWL.svg": "ccf6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c646";